import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Files from "./pages/Files";
import History from "./pages/History";
import ConerasAdmin from "./pages/ConerasAdmin";
import PublicDashboard from "./pages/PublicDashboard";

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { authenticated, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-zinc-950 text-zinc-400">Cargando...</div>;
  if (!authenticated) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  const { authenticated } = useAuth();

  return (
    <Routes>
      <Route path="/public" element={<PublicDashboard />} />
      <Route path="/login" element={authenticated ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/files" element={<PrivateRoute><Files /></PrivateRoute>} />
      <Route path="/conera/:coneraId" element={<PrivateRoute><History /></PrivateRoute>} />
      <Route path="/coneras/admin" element={<PrivateRoute><ConerasAdmin /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
